export const EVENT_CANNIBIS_INELIGIBLE_ERROR = 'ineligible with cannabis';
export const INVALID_DATA_PROVIDED_ERROR = 'The given data was invalid.';
export const EVENT_RISK_CLASS_9_ERROR = 'Event with risk class 9 ineligible.';
export const EVENT_RISK_CLASS_3_ERROR = 'Event with risk class 3 ineligible.';
export const SELECTION_REQUIRED = 'Please make a selection';
